import { GlassCard } from "@/components/ui/glass-card";
import { Info } from "lucide-react";

interface DeviceLogsProps {
  deviceId: string;
}

const DeviceLogs = ({ deviceId }: DeviceLogsProps) => {
  // No backend API for device logs yet
  return (
    <GlassCard variant="default" hover={false} className="p-6">
      <h2 className="text-xl font-semibold mb-4 text-foreground">Device Logs</h2>
      <div className="text-center py-12 text-muted-foreground">
        <Info className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-lg font-medium mb-2">Coming Soon</p>
        <p className="text-sm">Device logs require backend Audit Logs APIs.</p>
      </div>
    </GlassCard>
  );
};

export default DeviceLogs;
